import * as React from 'react';
import { useSelector } from 'react-redux';
import { selector } from './selectors';
import AuthModal from 'shared/components/AuthModal';
import PasswordResetSuccessModal from 'shared/components/PasswordResetSuccessModal';
import OrderSubmitModal from 'components/OrderSubmitModal';
import OrderSubmittedModal from 'components/OrderSubmittedModal';
import FirstLoginModal from 'components/FirstLoginModal';
import SellSubmittedModal from 'components/SellSubmittedModal';
import IdeaPositionDetailsModal from 'modules/IdeaPositionDetailsModal';
import StockPositionDetailsModal from 'modules/StockPositionDetailsModal';
import { SuccessDepositModal } from 'shared/components/SuccessDepositModal';

export const OldContainer: React.FC = () => {
  const { visible } = useSelector(selector);

  const [isMounted, mount] = React.useState(false);

  React.useEffect(() => mount(true), []);

  if (!isMounted) {
    return null;
  }

  switch (visible) {
    case 'authentication':
      return <AuthModal />;

    case 'passwordResetSuccess':
      return <PasswordResetSuccessModal />;

    case 'orderSubmit':
      return <OrderSubmitModal />;

    case 'orderSubmitted':
      return <OrderSubmittedModal />;

    case 'firstLogin':
      return <FirstLoginModal />;

    case 'sellSubmitted':
      return <SellSubmittedModal />;

    case 'positionDetailsIdea':
      return <IdeaPositionDetailsModal />;

    case 'positionDetailsStock':
      return <StockPositionDetailsModal />;

    case 'depositSuccess':
      return <SuccessDepositModal />;

    default:
      return null;
  }
};
